import { ACTIONS } from 'Components/Forms/FormReducers/SelectInputReducer';
import { displayErrors } from 'Components/Messages/ErrorMessage';
import React, { useState } from 'react';
import { Badge, Button, Form } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';




function FilterDropdown({ fieldData, inputDispatch, classes, filteredResults, startVal }) {
    console.log(fieldData);

    const handleInputSelectChange = (dispatch, value) => {
        dispatch({
            type: ACTIONS.SELECT_CHANGE,
            value: value
        })
    }

    return (
        <>
            <Dropdown drop="down" align="start"  className={classes}>
                <Dropdown.Toggle id="dropdown-custom-components" className="py-2 w-100 d-flex justify-content-between">
                    <div className="d-flex flex-row align-items-center gap-2 overflow-hidden">
                        <div className="dropdown-item-name">{fieldData.getDisplayValue(fieldData.options)}</div>
                        {
                            startVal!=fieldData.value 
                            ?
                                <Badge bg="filter-count" className="d-flex position-static filter-count bodyXS semibold">{filteredResults}</Badge>
                            :   null
                        }
                    </div>
                    <div className="position-relative end-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M16.59 8.29501L12 12.875L7.41 8.29501L6 9.70501L12 15.705L18 9.70501L16.59 8.29501Z" fill="#071E31"/>
                        </svg>
                    </div>
                </Dropdown.Toggle>

                <Dropdown.Menu className="w-100 flex-column" flip={false}>
                    {
                        fieldData.options.map((op)=>{
                            return(
                                <Dropdown.Item 
                                    as={Button}
                                    className='text-wrap'
                                    eventKey={op.value}
                                    onClick={(e)=>{
                                        handleInputSelectChange(inputDispatch,op.value);
                                    }}
                                >
                                    {op.displayValue}
                                </Dropdown.Item>
                            );
                        })
                    }
                </Dropdown.Menu>
                {/* <Form.Control.Feedback  type="invalid" className={fieldData.validation.isInvalid ? "is-invalid mt-3 text-start" : ""}>
                    {displayErrors(fieldData.name, fieldData.validation.errors)}
                </Form.Control.Feedback> */}
            </Dropdown>

        </>
    );
}

export default FilterDropdown;
